import { Injectable } from '@angular/core';
import { ContentService, HrefResolverService } from '@blk/cwp-ng-framework';
import { HeaderComponentDCR } from '@ddt-web/config';
import * as uniqBy from 'lodash/uniqBy';

@Injectable({ providedIn: 'root' })
export class ProspectusEmailService {
	private readonly MAILTO_LINK = 'mailto:?';
	private mailSubject;

	constructor(private contentService: ContentService, private hrefResolver: HrefResolverService) {
		this.mailSubject = 'Subject=' + encodeURIComponent(this.contentService.get('EMAIL_PROSPECTUS_SUBJECT', HeaderComponentDCR['EMAIL_PROSPECTUS_SUBJECT']));
	}

	public getMailToLink(holdings: any[]): string {
		const mailBody = this.generateMailBody(holdings);
		if (mailBody) {
			return this.MAILTO_LINK + this.mailSubject + '&body=' + mailBody;
		}
		return null;
	}

	private generateMailBody(holdings: any[]): string {
		const baseUrl = this.contentService.get('BASE_URL', HeaderComponentDCR['BASE_URL']);
		const prospectusBody = this.contentService.get('EMAIL_PROSPECTUS_BODY', HeaderComponentDCR['EMAIL_PROSPECTUS_BODY']);

		const listedUrls = uniqBy(holdings, 'cusip')
			.map(holding => `${holding.ticker}: ${baseUrl}${holding.cusip}`)
			.join('\n');
		const staticMailUrl = encodeURIComponent(prospectusBody + '\n\n' + listedUrls);

		if (this.checkMailToString(staticMailUrl)) {
			return staticMailUrl;
		} else {
			const joinedCusips = uniqBy(holdings, 'cusip')
				.map(holding => holding.cusip)
				.join(':');
			const dynamicUrl = this.hrefResolver.getResolvedUrl('prospectusUrl');
			const dynamicMailBody = encodeURIComponent(prospectusBody + '\n\n' + dynamicUrl + `?cusips=${joinedCusips}`);
			if (this.checkMailToString(dynamicMailBody)) {
				return dynamicMailBody;
			} else {
				console.log('Generate client report disabled. URL link generated for mailTo body is too long');
				return null;
			}
		}
	}

	/**
	 * Given a mailTo string, check whether it is valid. The deciding factor is the length of the url which is limited to 2029 for IE.
	 * @ param mailString
	 */
	private checkMailToString(mailString: string, maxSize: number = 2028): boolean {
		return mailString.length < maxSize;
	}
}
